import { render, staticRenderFns } from "./PointProgramsEditProgramContest.vue?vue&type=template&id=4f90ffb0&scoped=true&"
import script from "./PointProgramsEditProgramContest.vue?vue&type=script&lang=js&"
export * from "./PointProgramsEditProgramContest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f90ffb0",
  null
  
)

export default component.exports